"use client"

import { useEffect } from "react"
import { useMauticTracking } from "@/hooks/useMauticTracking"

export function MauticArticleTracker({ title }: { title: string }) {
   const { trackEvent } = useMauticTracking()

   useEffect(() => {
      trackEvent("Content", "Article Read", title)
   }, [title, trackEvent])

   return null
}
